/**
 * Row-level icon button used on the coach Students and Leads lists: a 32px
 * bordered button with a primary-colored icon for the main row actions.
 */
export const borderedActionButtonStyles = theme => ({
  boxSizing: 'border-box',
  padding: 6,
  width: 32,
  height: 32,
  borderRadius: 8,
  border: '1px solid #C4C7C9',
  backgroundColor: theme.palette.common.white,
  color: theme.palette.primary.main,
  transition: theme.transitions.create(
    ['background-color', 'border-color', 'color'],
    { duration: theme.transitions.duration.short },
  ),
  '&:hover': {
    backgroundColor: '#EBEBEB',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  '& .MuiSvgIcon-root': {
    width: 20,
    height: 20,
    fontSize: 20,
  },
})
